import React from 'react';
import Songlist from '../components/Songlist';

const SonglistPage: React.FC = () => {
  return <Songlist />;
};

export default SonglistPage;
